import { useQuery } from "@tanstack/react-query";
import { api } from "../client";
import { queryKeys } from "../query-keys";

export function useUserProfileSelect(enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.userProfile,
    enabled: enabled,
    queryFn: async () => {
      const res = await api.userProfileApi.apiProfileGet();
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
